import { Box, Fade, Typography } from "@mui/material";
import menuItemAdmin from "menu-items/menuItemsAdmin";
import menuItemRudyAdmin from "menu-items/menuItemsRudyAdmin";
import menuItemVendedor from "menu-items/menuItemsVendedor";
import { memo } from "react";
import NavGroup from "./NavGroup";

const MenuList = ({ negocio }) => {
  const renderNavItems = (items) =>
    items.map((item, index) => {
      if (item.type === "group") {
        return (
          <Fade in={true} timeout={300 + index * 100} key={item.id}>
            <Box>
              <NavGroup item={item} />
            </Box>
          </Fade>
        );
      }
      return (
        <Typography key={item.id} variant="h6" color="error" align="center">
          Menu Items Error
        </Typography>
      );
    });

  if (negocio.negocio_id === 445) {
    if (negocio.rol === "ADMIN") {
      return <>{renderNavItems(menuItemRudyAdmin.items)}</>;
    }
    return <>{renderNavItems(menuItemVendedor.items)}</>;
  }

  const items = negocio.rol === "ADMIN" ? menuItemAdmin.items : menuItemVendedor.items;

  return <>{renderNavItems(items)}</>;
};

export default memo(MenuList);
